import { render, staticRenderFns } from "./Addon.vue?vue&type=template&id=47b37168&scoped=true&"
import script from "./Addon.vue?vue&type=script&lang=js&"
export * from "./Addon.vue?vue&type=script&lang=js&"
import style0 from "./Addon.vue?vue&type=style&index=0&id=47b37168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b37168",
  null
  
)

export default component.exports